import c from 'classnames';
import { useLinks } from 'core/components/linksContext';
import { showSnackbar } from 'core/components/snackbar';
import { title as titleStyle } from 'core/style';
import injectSheet, { createStyles } from 'core/style/injectSheet';
import { ITheme, WithStyles } from 'core/style/interfaces';
import { formatToLocalDayMonthYear, isHtmlEmpty, isImpossibleDate } from 'core/utils';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { Material } from 'site/graphql';
import { formItemCardStyles } from './formItemCardStyles';

type IPrivateProductMaterialCardProps = {
    material: Pick<Material, 'id' | 'description' | 'title' | 'date' | 'link'>;
    noAccess: boolean;
} & WithStyles<typeof styles>;

const PrivateProductMaterialCard: React.FC<IPrivateProductMaterialCardProps> = ({ classes, material, noAccess }) => {
    const { description, title, date, link } = material;
    const links = useLinks();
    const history = useHistory();

    const handleClick = () => {
        if (noAccess) {
            history.push(links.courseList.url());
            return;
        }

        if (link) {
            window.open(`${link}`, '_blank');
        } else {
            showSnackbar({
                snackbarErrors: [
                    {
                        message: `Ссылка на скачивание будет доступна позднее`,
                    },
                ],
            });
        }
    };

    return (
        <div className={c(classes.root, { [classes.darkenedRoot]: noAccess })}>
            <div className={classes.content}>
                <h3 className={classes.title}>{title}</h3>
                <div
                    className={classes.shortDesc}
                    dangerouslySetInnerHTML={{ __html: !isHtmlEmpty(description) ? description : '' }}
                />
                {date && !isImpossibleDate(date) && (
                    <div className={classes.dateBlock}>{formatToLocalDayMonthYear(date)}</div>
                )}
                <a className={classes.button} onClick={handleClick}>
                    {noAccess ? 'Открыть доступ' : 'Скачать'}
                </a>
            </div>
        </div>
    );
};

const styles = (theme: ITheme) =>
    createStyles({
        ...formItemCardStyles(theme),
        title: {
            ...titleStyle({
                size: 'h3',
            }),
            fontSize: '1.15rem',
            marginBottom: '1.25rem',
        },
        dateBlock: {
            textAlign: 'end',
            marginBottom: 0.5 + 'rem',
            fontSize: 0.8 + 'rem',
        },
    });

export default injectSheet(styles, 'PrivateProductMaterialCard')(PrivateProductMaterialCard);
